import ApplicationsRouter from '@/components/pages/application/index.vue';
import MailList from '@/components/pages/mails/List.vue'
import MailDetail from '@/components/pages/mails/Detail.vue'
import SendBulkStudents from '@/components/pages/mails/SendBulkStudents.vue'
import SendBulkTutors from '@/components/pages/mails/SendBulkTutors.vue'
import templates from './templates'

export default {
  path: '/mails',
  component: ApplicationsRouter,
  children: [
    templates,
    {
      path: 'send_bulk/students',
      name: 'SendMailToStudents',
      component: SendBulkStudents,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: 'send_bulk/tutors',
      name: 'SendMailToTutors',
      component: SendBulkTutors,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '',
      name: 'Mails',
      component: MailList,
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: ':notificationId',
      name: 'MailDetail',
      component: MailDetail,
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
